import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LoadingButton from "@mui/lab/LoadingButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import React, { FC, useState } from "react";
import { useSelector } from "react-redux";
import { patchCartOrderItemRequestModel } from "../../../../../api/apiRequestObjects";
import apis from "../../../../../api/apis";
import { APIResponseType } from "../../../../../config/enumApiResponseTypes";
import { notifyError } from "../../../../../config/toastNotification";
import { IPartnerOrderDetail } from "../../../../../interfaces/order";
import {
  FullfillmentAction,
  FullfillmentIssue,
  IPatchCartOrderItem,
} from "../../../../../interfaces/patchCart";
import styles from "./PatchCart.module.scss";
import { blueGrey } from "@mui/material/colors";
import { Add, ArrowBackIos, Remove } from "@material-ui/icons";

interface IProps {
  orderId: string | undefined;
  orderTypeCode: string | undefined;
  orderItems: IPartnerOrderDetail[] | undefined;
  onClick: any;
}

const PatchCart: FC<IProps> = ({
  orderTypeCode,
  orderId,
  orderItems,
  onClick,
}) => {
  const [selectedItemsForPatch, setSelectedItemsForPatch] = useState<
    IPatchCartOrderItem[]
  >([]);

  console.table(selectedItemsForPatch);
  const [itemQty, setItemQty] = useState(0);
  const [itemCounter, setItemCounter] = useState<any>({
    visible: false,
    item: null,
  });
  console.log("itemCounter " + itemQty);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [fulfillmentIssue, setfulfillmentIssue] = useState<String>("");
  // console.log(orderItems);

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);
  //console.log(user);

  const handlePatchCartItems = (e: any, itemdetails: IPartnerOrderDetail) => {
    const { checked } = e.target;
    //console.log(itemdetails.OrderItem.ItemCode);

    let patchCartOrderItem: IPatchCartOrderItem = {
      PartnerInstanceId: "",
      ItemCode: itemdetails.OrderItem.ItemCode,
      FullfillmentAction: "",
      FullfillmentIssue: "",
      AvailableItemCount: 0,
      SubstituteItemId: "",
      SubstituteItemQuantity: 0,
      OrderTypeCode: orderTypeCode ?? "",
    };

    if (checked === true) {
      /*       if (selectedItemsForPatch.length === 0) {
        selectedItemsForPatch.push(patchCartOrderItem);
      } else { */
      setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
        ...prev,
        patchCartOrderItem,
      ]);
      /* } */
    }
    if (checked === false) {
      const filteredItems = selectedItemsForPatch.filter(
        (x) => x.ItemCode !== patchCartOrderItem.ItemCode
      );
      setSelectedItemsForPatch(filteredItems);
      setfulfillmentIssue("");
      //console.log(index);
      // setselectedCount((prev: any) => [
      //   ...prev,
      //   selectedCount.splice(index, 1),
      // ]);

      //selectedItemsForPatch.splice(index, 1);
    }
    //console.log(selectedItemsForPatch);
  };

  //HANDLE FULFILMENT ISSUE
  const handlefulfillmentIssue = (e: any, itemdetails: IPartnerOrderDetail) => {
    const { value, checked } = e.target;
    //console.log(value);

    setfulfillmentIssue(value);

    setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) =>
      prev.map((x) =>
        x.ItemCode === itemdetails.OrderItem.ItemCode
          ? { ...x, FullfillmentIssue: value }
          : x
      )
    );
  };

  //HANDLE FULFILMENT ACTION
  const handleFullfillmentAction = (
    e: any,
    itemdetails: IPartnerOrderDetail
  ) => {
    const { value, checked } = e.target;
    //console.log(value);
    setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) =>
      prev.map((x) =>
        x.ItemCode === itemdetails.OrderItem.ItemCode
          ? { ...x, FullfillmentAction: value }
          : x
      )
    );
  };

  //partial available count setup
  const handlePartialAvailableCount = (
    e: any,
    itemdetails: IPartnerOrderDetail
  ) => {
    const { value, checked } = e.target;
    //console.log(value);
    setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) =>
      prev.map((x) =>
        x.ItemCode === itemdetails.OrderItem.ItemCode
          ? { ...x, FullfillmentAction: "", AvailableItemCount: value }
          : x
      )
    );
  };

  const handleNotify = async () => {
    //setcall(!call);
    //console.log(selectedItemsForPatch);

    setIsLoading(true);

    try {
      patchCartOrderItemRequestModel.OrderId = orderId ?? "";
      patchCartOrderItemRequestModel.PatchCartPartnerOrderItems =
        selectedItemsForPatch;
      patchCartOrderItemRequestModel.UID.UserKey = user.UserKey;
      patchCartOrderItemRequestModel.UID.LocationKey = user.LocationKey;
      patchCartOrderItemRequestModel.UID.CompanyKey = user.CompanyKey;
      patchCartOrderItemRequestModel.UID.EnvironmentName = user.EnvironmentName;

      const response = await apis.Orders.patchCart(
        patchCartOrderItemRequestModel
      );
      //console.log(response);

      if (response.ResponseType === APIResponseType.Success) {
        setIsLoading(false);
        alert("Successfully patched cart");
      } else {
        setIsLoading(false);
        alert("Failed to patch cart");
      }
    } catch (e) {
      setIsLoading(false);

      notifyError();
      //console.log(e);
    }
  };

  //handle sold out
  const handleSoldOut = (itemdetails: IPartnerOrderDetail) => {
    console.log(itemdetails.OrderItem.ItemCode);
    let patchCartOrderItem: IPatchCartOrderItem = {
      PartnerInstanceId: "",
      ItemCode: itemdetails.OrderItem.ItemCode,
      FullfillmentAction: "REMOVE_ITEM",
      FullfillmentIssue: "OUT_OF_ITEM",
      AvailableItemCount: 0,
      SubstituteItemId: "",
      SubstituteItemQuantity: 0,
      OrderTypeCode: orderTypeCode ?? "",
    };
    if (selectedItemsForPatch.length === 0) {
      setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
        ...prev,
        patchCartOrderItem,
      ]);
    } else {
      selectedItemsForPatch.some(
        (singleItem) => singleItem.ItemCode === itemdetails.OrderItem.ItemCode
      )
        ? setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) =>
            prev.map((singleItem) =>
              singleItem.ItemCode === itemdetails.OrderItem.ItemCode
                ? {
                    ...singleItem,
                    FullfillmentAction: "REMOVE_ITEM",
                    FullfillmentIssue: "OUT_OF_ITEM",
                    AvailableItemCount: 0,
                  }
                : singleItem
            )
          )
        : setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
            ...prev,
            patchCartOrderItem,
          ]);
    }
  };

  //handle partial available count
  const handlePartialAvailable = () => {
    // const { OrderItem } = itemCounter;
    //const { itemCode } = item;

    setItemCounter({ visible: false, item: null });
    setItemQty(0);
  };

  const handleReduceItem = (action: string) => {
    let patchCartOrderItem: IPatchCartOrderItem = {
      PartnerInstanceId: "",
      ItemCode: itemCounter.item.OrderItem.ItemCode,
      FullfillmentAction: "",
      FullfillmentIssue: "PARTIAL_AVAILABILITY",
      AvailableItemCount: 1,
      SubstituteItemId: "",
      SubstituteItemQuantity: 0,
      OrderTypeCode: orderTypeCode ?? "",
    };
    if (action === "add") {
      setItemQty(itemQty + 1);
      if (selectedItemsForPatch.length === 0) {
        setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
          ...prev,
          patchCartOrderItem,
        ]);
      } else {
        selectedItemsForPatch.some(
          (singleItem) =>
            singleItem.ItemCode === itemCounter.item.OrderItem.ItemCode
        )
          ? setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) =>
              prev.map((singleItem) =>
                singleItem.ItemCode === itemCounter.item.OrderItem.ItemCode
                  ? {
                      ...singleItem,
                      FullfillmentAction: "",

                      FullfillmentIssue: "PARTIAL_AVAILABILITY",
                      AvailableItemCount: singleItem.AvailableItemCount + 1,
                    }
                  : singleItem
              )
            )
          : setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
              ...prev,
              patchCartOrderItem,
            ]);
      }
    } else if (action === "reduce") {
      setItemQty(itemQty - 1);
      if (selectedItemsForPatch.length === 0) {
        setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
          ...prev,
          patchCartOrderItem,
        ]);
      } else {
        selectedItemsForPatch.some(
          (singleItem) =>
            singleItem.ItemCode === itemCounter.item.OrderItem.ItemCode
        )
          ? setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) =>
              prev.map((singleItem) =>
                singleItem.ItemCode === itemCounter.item.OrderItem.ItemCode
                  ? {
                      ...singleItem,
                      FullfillmentAction: "",

                      FullfillmentIssue: "PARTIAL_AVAILABILITY",
                      AvailableItemCount: singleItem.AvailableItemCount - 1,
                    }
                  : singleItem
              )
            )
          : setSelectedItemsForPatch((prev: IPatchCartOrderItem[]) => [
              ...prev,
              patchCartOrderItem,
            ]);
      }
    }
  };
  const handleCancel = () => {
    setItemCounter({ visible: false, item: null });
    setItemQty(0);
  };

  return (
    <>
      <div className={styles.popup_box}>
        <div className={styles.box}>
          <div className={styles.title_container}>
            <ArrowBackIosNewOutlined onClick={onClick} />
            <h3>Edit - Patch Cart</h3>
          </div>
          <div className={styles.desc}>
            <span>
              Select any item that are out of stock or partial available, and
              we'll notify customer. They'll have 10 minutes decide whether they
              want to continue with this order or change it.
            </span>
          </div>
          <div className={styles.item_list_container}>
            {orderItems?.map((orderItem: IPartnerOrderDetail) => (
              <div className={styles.item_card}>
                {/* {itemdetails.OrderItem.ItemCode} */}
                <div className={styles.dropdown}>
                  <button className={styles.dropbtn}>
                    {orderItem.ItemQuantity + "    "}
                    <KeyboardArrowDownIcon />
                  </button>

                  <div className={styles.dropdown_content}>
                    <label onClick={() => handleSoldOut(orderItem)}>
                      Mark as Sold Out
                    </label>
                    <label
                      onClick={() =>
                        setItemCounter({ visible: true, item: orderItem })
                      }
                    >
                      Reduce Quantity
                    </label>
                  </div>
                </div>
                <div className={styles.item_name}>
                  {orderItem.OrderItem.ItemName}
                </div>
                <div className={styles.item_price}>
                  {(
                    orderItem.TransactionPrice * orderItem.ItemQuantity
                  ).toFixed(2)}
                </div>
              </div>
            ))}

            {/* {orderItems?.map((orderItem: IPartnerOrderDetail) => (
              <>
                <div className={styles.item_card}>
                  <div className={styles.cart_child_left}>
                    <label className={styles.container}>
                      <p>{orderItem.OrderItem.ItemName}</p>

                      <input
                        type="checkbox"
                        onChange={(e) => handlePatchCartItems(e, orderItem)}
                      />
                      <span className={styles.checkmark}></span>
                    </label>
                  </div>
                  <div className={styles.cart_child_center}>
                    <span>{orderItem.ItemQuantity}</span>
                  </div>
                  <div className={styles.cart_child_right}>
                    <span>
                      {(
                        orderItem.TransactionPrice * orderItem.ItemQuantity
                      ).toFixed(2)}
                    </span>
                  </div>

                  <div className={styles.cart_child_hard_right}>
                    <label htmlFor="">
                      Current stock : {orderItem.AvailableStockCount}
                    </label>
                  </div>
                </div>

                {selectedItemsForPatch.length > 0 ? (
                  <>
                    {selectedItemsForPatch.map(
                      (singleItem: IPatchCartOrderItem) =>
                        singleItem.ItemCode === orderItem.OrderItem.ItemCode ? (
                          <>
                            <div
                              key={singleItem.ItemCode}
                              className={styles.fullfilment_issue_container}
                            >
                              <div className={styles.fullfilment_issue}>
                                <form className={styles.fullfilment_issue}>
                                  <label className={styles.radio_container}>
                                    Out of Item
                                    <input
                                      type="radio"
                                      name="radio"
                                      value={
                                        FullfillmentIssue[
                                          FullfillmentIssue.OUT_OF_ITEM
                                        ]
                                      }
                                      onChange={(e: any) =>
                                        handlefulfillmentIssue(e, orderItem)
                                      }
                                    />
                                    <span
                                      className={styles.radio_checkmark}
                                    ></span>
                                  </label>
                                  <label className={styles.radio_container}>
                                    Partailly Available
                                    <input
                                      type="radio"
                                      name="radio"
                                      value={
                                        FullfillmentIssue[
                                          FullfillmentIssue.PARTIAL_AVAILABILITY
                                        ]
                                      }
                                      onChange={(e: any) =>
                                        handlefulfillmentIssue(e, orderItem)
                                      }
                                    />
                                    <span
                                      className={styles.radio_checkmark}
                                    ></span>
                                  </label>
                                </form>
                              </div>

                              {selectedItemsForPatch.map((singleItem) =>
                                singleItem.ItemCode ===
                                  orderItem.OrderItem.ItemCode &&
                                singleItem.FullfillmentIssue ===
                                  "OUT_OF_ITEM" ? (
                                  <>
                                    {" "}
                                    <div
                                      key={singleItem.ItemCode}
                                      className={styles.filfillment_action}
                                    >
                                      <form>
                                        <label
                                          className={styles.radio_container}
                                        >
                                          Remove Item
                                          <input
                                            type="radio"
                                            name="radio"
                                            value={
                                              FullfillmentAction[
                                                FullfillmentAction.REMOVE_ITEM
                                              ]
                                            }
                                            onChange={(e: any) =>
                                              handleFullfillmentAction(
                                                e,
                                                orderItem
                                              )
                                            }
                                          />
                                          <span
                                            className={styles.radio_checkmark}
                                          ></span>
                                        </label>

                                        <label
                                          className={styles.radio_container}
                                        >
                                          Replace Item
                                          <input
                                            type="radio"
                                            name="radio"
                                            value={
                                              FullfillmentAction[
                                                FullfillmentAction
                                                  .REPLACE_FOR_ME
                                              ]
                                            }
                                            checked={
                                              singleItem.FullfillmentAction ===
                                                "REPLACE_FOR_ME" && true
                                            }
                                            onChange={(e: any) =>
                                              handleFullfillmentAction(
                                                e,
                                                orderItem
                                              )
                                            }
                                          />
                                          <span
                                            className={styles.radio_checkmark}
                                          ></span>
                                        </label>
                                      </form>
                                    </div>
                                  </>
                                ) : null
                              )}

                              {selectedItemsForPatch.map((singleItem) =>
                                singleItem.ItemCode ===
                                  orderItem.OrderItem.ItemCode &&
                                singleItem.FullfillmentIssue ===
                                  "PARTIAL_AVAILABILITY" ? (
                                  <>
                                    {" "}
                                    <div key={singleItem.ItemCode}>
                                      <div
                                        className={
                                          styles.filfillment_action_partial
                                        }
                                      >
                                        <label>Available stock : </label>
                                        <input
                                          style={{ width: "50px" }}
                                          type="number"
                                          min="1"
                                          onChange={(e: any) =>
                                            handlePartialAvailableCount(
                                              e,
                                              orderItem
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : null
                              )}
                            </div>
                          </>
                        ) : null
                    )}
                  </>
                ) : null}

                <br />
              </>
            ))} */}
          </div>
          <div className={styles.bottom_button_container}>
            <LoadingButton
              sx={{ color: blueGrey[900], borderColor: blueGrey[800] }}
              loading={isLoading}
              variant="outlined"
              onClick={handleNotify}
              disabled={selectedItemsForPatch.length > 0 ? false : true}
            >
              Notify customer
            </LoadingButton>
            {/*             <button
              className={styles.bottom_button}
              onClick={handleNotify}
              disabled={selectedItemsForPatch.length > 0 ? false : true}
            >
              Notify customer
            </button> */}
          </div>
        </div>
      </div>
      {itemCounter.visible && (
        <div className={styles.notify_popup_container}>
          <div className={styles.notify_popup}>
            <div className={styles.notify_popup_header}>
              <ArrowBackIos />
              <span>Reduce item quantity</span>
            </div>
            {/* <div className={styles.notify_popup_label}>
              <p>How many can you provide?</p>
            </div> */}

            <div className={styles.item_counter}>
              <button
                disabled={itemQty === 0 ? true : false}
                onClick={() => handleReduceItem("reduce")}
              >
                <Remove style={{ fontSize: 50 }} />
              </button>
              <div className={styles.available_quantity}>
                <h1>{itemQty}</h1>
                <p>Available</p>
              </div>

              <button onClick={() => handleReduceItem("add")}>
                <Add style={{ fontSize: 50 }} />
              </button>
            </div>
            <div className={styles.popup_button}>
              <button
                className={styles.popup_button_cancel}
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className={styles.popup_button_confirm}
                onClick={handlePartialAvailable}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PatchCart;
